import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import 'lib-flexible';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import GlobalComponents from '@/components/global'
import toastRegistry from './components/toast'
import VueClipboard from 'vue-clipboard2'

import animate from 'animate.css'
import '@/styles/reset.scss';
import 'vant/lib/index.css'
import { Collapse, CollapseItem, Popup, Area } from 'vant'

Vue.config.productionTip = false;

Vue.use(toastRegistry)
Vue.use(VueAwesomeSwiper)
Vue.use(GlobalComponents)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(animate)
Vue.use(VueClipboard)
Vue.use(Popup)
Vue.use(Area)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
